<template>
  <div
    id="privilege-information-redeem-limit"
    class="form-custom"
  >
    <b-row class="redeem-limit-form">
      <b-col cols="12">
        <b-card
          no-body
          class="mb-1 pb-2"
        >
          <b-card-header>
            <span class="information-header">Redeem - Limit</span>
          </b-card-header>
          <div class="row px-5">
            <div class="col-12">
              <!-- <div>Body2</div> -->
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="row">
                    <div class="col col-md-6">
                      <b-form-group
                        :label="'Redeem - Overall'"
                        label-for="'redeem-overall"
                        class=""
                      >
                        <b-form-input
                          id="redeem-overall"
                          v-model="formData.RedeemOverall"
                          @input="
                            $emit('onNumberInput', $event, 'RedeemOverall')
                          "
                        />
                      </b-form-group>
                    </div>
                    <div class="col col-md-6">
                      <b-form-group
                        :label="'Redeem - per Day'"
                        label-for="'redeem-per-day"
                        class=""
                      >
                        <b-form-input
                          id="redeem-per-day"
                          v-model="formData.RedeemDay"
                          @input="$emit('onNumberInput', $event, 'RedeemDay')"
                        />
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <b-form-group
                        :label="'Redeem - per Month'"
                        label-for="'Redeem-per-month"
                        class=""
                      >
                        <b-form-input
                          id="Redeem-per-month"
                          v-model="formData.RedeemMonth"
                          @input="$emit('onNumberInput', $event, 'RedeemMonth')"
                        />
                      </b-form-group>
                    </div>
                    <div class="col col-md-6">
                      <b-form-group
                        :label="'Redeem - per Customer'"
                        label-for="'redeem-per-customer"
                        class=""
                      >
                        <b-form-input
                          id="redeem-per-customer"
                          v-model="formData.RedeemCustomer"
                          @input="
                            $emit('onNumberInput', $event, 'RedeemCustomer')
                          "
                        />
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <b-form-group
                        :label="'Redeem - per Customer / Day'"
                        label-for="'redeem-per-customer-day"
                        class=""
                      >
                        <b-form-input
                          id="redeem-per-customer-day"
                          v-model="formData.RedeemCustomerDay"
                          @input="
                            $emit('onNumberInput', $event, 'RedeemCustomerDay')
                          "
                        />
                      </b-form-group>
                    </div>
                    <div class="col col-md-6">
                      <b-form-group
                        :label="'Redeem - per Customer / Month'"
                        label-for="'redeem-per-ustomer-month"
                        class=""
                      >
                        <b-form-input
                          id="redeem-per-ustomer-month"
                          v-model="formData.RedeemCustomerMonth"
                          @input="
                            $emit(
                              'onNumberInput',
                              $event,
                              'RedeemCustomerMonth',
                            )
                          "
                        />
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  components: {
    
  },
  props: { formData: { type: Object, default: {} } },
  setup() {
    return {}
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/privilege/privilege-information-limit.css';
</style>
